
/**
 * @param {Array} data
 * @returns {Boolean}
 */

export default function c (data, value) {
  if (data && data instanceof Array && data.length > 0) {
    if (value.indexOf(',') > -1) {
      let prems = value.split(',')
      return data.some(ele => prems.indexOf(ele.funcType) > -1)
    } else {
      return data.some(ele => ele.funcType === value)
    }
  } else {
    return true
  }
}
